import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../assets/caprock/front-images/go-to-account.svg'


const _hoisted_1 = {
  class: "right-sidebar-profile",
  tabindex: "1",
  style: {"overflow":"auto","z-index":"1!important","background":"#f7f8fa"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"80px"} }, null, -1)
const _hoisted_3 = { class: "row mr-3 ml-1" }
const _hoisted_4 = { class: "col-12 mt-4" }
const _hoisted_5 = { class: "border-radius-10 d-block text-center" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "font-grey font-size-18 pb-1" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "font-grey font-size-15" }
const _hoisted_11 = {
  key: 0,
  class: "ml-1"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 0,
  class: "col-12 mt-4 ml-1"
}
const _hoisted_14 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_15 = { class: "font-white font-size-14" }
const _hoisted_16 = {
  style: {"color":"white !important"},
  class: "font-white font-size-12"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", {
  style: {"height":"35px"},
  src: _imports_0,
  class: "p-cursor ml-3"
}, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 mt-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("h5", { class: "font-grey font-size-16 p-0 m-0" }, [
      /*#__PURE__*/_createElementVNode("b", null, "My Profile")
    ])
  ])
], -1)
const _hoisted_19 = { class: "col-12 mt-4" }
const _hoisted_20 = { class: "d-flex align-items-center" }
const _hoisted_21 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  width: "35px",
  height: "35px",
  version: "1.1",
  style: {"shape-rendering":"geometricPrecision","text-rendering":"geometricPrecision","image-rendering":"optimizeQuality","fill-rule":"evenodd","clip-rule":"evenodd","margin":"0 25px 0 0"},
  viewBox: "0 0 35 35",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("defs", null, null, -1)
const _hoisted_23 = { id: "Layer_x0020_1" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("metadata", { id: "CorelCorpID_0Corel-Layer" }, null, -1)
const _hoisted_25 = { id: "_863461543616" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("g", { id: "_863458324208" }, [
  /*#__PURE__*/_createElementVNode("path", {
    class: "fil1",
    d: "M22.5 23.87l-10.01 0c-0.4,0 -0.72,-0.33 -0.72,-0.72 0,0 0,0 0,0l0 -0.71c0,-0.59 0.37,-1.44 2.15,-2.15 1.14,-0.44 2.35,-0.69 3.57,-0.72 1.23,0.03 2.44,0.28 3.58,0.72 1.77,0.71 2.14,1.56 2.14,2.15l0 0.71c0,0 0,0 0,0 0,0.4 -0.32,0.72 -0.71,0.72 0,0 0,0 0,0l0 0zm-5.01 -5.72c-1.58,0 -2.86,-1.28 -2.86,-2.86 0,-1.58 1.28,-2.86 2.86,-2.86 1.58,0 2.86,1.28 2.86,2.86 0,1.57 -1.28,2.85 -2.86,2.86l0 0z"
  })
], -1)
const _hoisted_27 = { class: "col-12 mt-4" }
const _hoisted_28 = { class: "d-flex align-items-center" }
const _hoisted_29 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  width: "35px",
  height: "35px",
  version: "1.1",
  style: {"shape-rendering":"geometricPrecision","text-rendering":"geometricPrecision","image-rendering":"optimizeQuality","fill-rule":"evenodd","clip-rule":"evenodd","margin":"0 25px 0 0"},
  viewBox: "0 0 35 35",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("defs", null, null, -1)
const _hoisted_31 = { id: "Layer_x0020_1" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("metadata", { id: "CorelCorpID_0Corel-Layer" }, null, -1)
const _hoisted_33 = { id: "_863461543616" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("g", { id: "_863458324208" }, [
  /*#__PURE__*/_createElementVNode("path", {
    class: "fil1",
    d: "M22.5 23.87l-10.01 0c-0.4,0 -0.72,-0.33 -0.72,-0.72 0,0 0,0 0,0l0 -0.71c0,-0.59 0.37,-1.44 2.15,-2.15 1.14,-0.44 2.35,-0.69 3.57,-0.72 1.23,0.03 2.44,0.28 3.58,0.72 1.77,0.71 2.14,1.56 2.14,2.15l0 0.71c0,0 0,0 0,0 0,0.4 -0.32,0.72 -0.71,0.72 0,0 0,0 0,0l0 0zm-5.01 -5.72c-1.58,0 -2.86,-1.28 -2.86,-2.86 0,-1.58 1.28,-2.86 2.86,-2.86 1.58,0 2.86,1.28 2.86,2.86 0,1.57 -1.28,2.85 -2.86,2.86l0 0z"
  })
], -1)
const _hoisted_35 = { class: "col-12 mt-4 mb-5" }
const _hoisted_36 = { class: "d-flex align-items-center" }
const _hoisted_37 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  width: "35px",
  height: "35px",
  version: "1.1",
  style: {"shape-rendering":"geometricPrecision","text-rendering":"geometricPrecision","image-rendering":"optimizeQuality","fill-rule":"evenodd","clip-rule":"evenodd","margin":"0 25px 0 0"},
  viewBox: "0 0 35 35",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}
const _hoisted_38 = { id: "Layer_x0020_1" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("metadata", { id: "CorelCorpID_0Corel-Layer" }, null, -1)
const _hoisted_40 = { id: "_864957106832" }
const _hoisted_41 = /*#__PURE__*/_createStaticVNode("<g><path class=\"fil1\" d=\"M22.94 23.66l-10.37 0c-0.81,0 -1.48,-0.66 -1.48,-1.48l0 -10.37c0,-0.82 0.67,-1.48 1.48,-1.48l3.1 0c0.31,-0.89 1.15,-1.48 2.09,-1.48 0.94,0 1.77,0.59 2.09,1.48l3.09 0c0,0 0,0 0,0 0.82,0 1.48,0.66 1.48,1.48l0 10.37c0,0.81 -0.66,1.48 -1.48,1.48l0 0z\"></path><path class=\"fil0\" d=\"M17.78 10.18c-0.4,0 -0.74,0.33 -0.74,0.74 0,0.41 0.34,0.74 0.74,0.74 0.41,0 0.74,-0.33 0.74,-0.74 0,-0.41 -0.33,-0.74 -0.74,-0.74l0 0z\"></path><path class=\"fil0\" d=\"M14.37 13.76c-0.41,0 -0.74,0.33 -0.74,0.74 0,0.41 0.33,0.74 0.74,0.74l6.39 0c0.41,0 0.74,-0.33 0.74,-0.74 0,-0.41 -0.33,-0.74 -0.74,-0.74l-6.39 0z\"></path><path class=\"fil0\" d=\"M14.37 16.28c-0.41,0 -0.74,0.33 -0.74,0.74 0,0.41 0.33,0.74 0.74,0.74l6.39 0c0.41,0 0.74,-0.33 0.74,-0.74 0,-0.41 -0.33,-0.74 -0.74,-0.74l-6.39 0z\"></path><path class=\"fil0\" d=\"M14.37 18.81c-0.41,0 -0.74,0.33 -0.74,0.74 0,0.41 0.33,0.74 0.74,0.74l4.73 0c0.4,0 0.74,-0.33 0.74,-0.74 0,-0.41 -0.34,-0.74 -0.74,-0.74l-4.73 0z\"></path></g>", 1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", {
  class: "doc_alert d-none",
  id: "doc_alert"
}, "2", -1)
const _hoisted_43 = {
  class: "text-center font-gray",
  style: {"background":"#1a3b8b1f","font-size":"12px","border":"1px solid grey","margin-top":"30px","margin-bottom":"0px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("aside", null, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              class: "viewProfilePic",
              onError: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadImage())),
              src: _ctx.profile_url,
              style: {"width":"100px","height":"100px","object-fit":"cover","border-radius":"50%","margin-bottom":"30px"}
            }, null, 40, _hoisted_6),
            _createElementVNode("h5", _hoisted_7, [
              (_ctx.user_info.u_type!=2)
                ? (_openBlock(), _createElementBlock("b", _hoisted_8, _toDisplayString(_ctx.user_info.user_name), 1))
                : _createCommentVNode("", true),
              (_ctx.user_info.u_type==2)
                ? (_openBlock(), _createElementBlock("b", _hoisted_9, _toDisplayString(_ctx.user_info.user_company_name), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("h5", _hoisted_10, "Member since : " + _toDisplayString(_ctx.user_info.join_date), 1)
          ])
        ]),
        (_ctx.customer_accounts.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customer_accounts, (ac) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: ac.userac_id,
                  class: "ml-1",
                  onClick: ($event: any) => (_ctx.$router.push('/my-account/'+ac.ac_slug))
                }, [
                  (ac.userac_status==1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("span", _hoisted_14, [
                          _createElementVNode("div", {
                            class: _normalizeClass([[{active: _ctx.active_page==ac.ac_slug},ac.ac_gradients], "card p-cursor border-radius-8 d-block align-items-center pb-1 pt-2 px-3"]),
                            style: {"width":"165px"}
                          }, [
                            _createElementVNode("h5", _hoisted_15, [
                              _createElementVNode("b", null, _toDisplayString(ac.ac_name), 1)
                            ]),
                            _createElementVNode("h5", _hoisted_16, _toDisplayString(ac.default_currency_icon) + " " + _toDisplayString(ac.default_currency_balance.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2})), 1)
                          ], 2),
                          _hoisted_17
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_12))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _hoisted_18,
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("span", _hoisted_20, [
            (_openBlock(), _createElementBlock("svg", _hoisted_21, [
              _hoisted_22,
              _createElementVNode("g", _hoisted_23, [
                _hoisted_24,
                _createElementVNode("g", _hoisted_25, [
                  _createElementVNode("path", {
                    class: _normalizeClass([{fil2:_ctx.active_page=='profile'}, "fil0"]),
                    d: "M17.49 2.83l0 0c8.46,0 15.32,6.86 15.32,15.32l0 0c0,8.46 -6.86,15.32 -15.32,15.32l0 0c-8.46,0 -15.32,-6.86 -15.32,-15.32l0 0c0,-8.46 6.86,-15.32 15.32,-15.32z"
                  }, null, 2)
                ]),
                _hoisted_26
              ])
            ])),
            _createElementVNode("h5", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/my-profile'))),
              class: "font-grey font-size-16 p-0 m-0 p-cursor"
            }, [
              _createElementVNode("b", {
                style: _normalizeStyle(_ctx.active_page=='profile'? 'color:black' : '')
              }, "Personal information", 4)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("span", _hoisted_28, [
            (_openBlock(), _createElementBlock("svg", _hoisted_29, [
              _hoisted_30,
              _createElementVNode("g", _hoisted_31, [
                _hoisted_32,
                _createElementVNode("g", _hoisted_33, [
                  _createElementVNode("path", {
                    class: _normalizeClass([{fil2:_ctx.active_page=='beneficiary'}, "fil0"]),
                    d: "M17.49 2.83l0 0c8.46,0 15.32,6.86 15.32,15.32l0 0c0,8.46 -6.86,15.32 -15.32,15.32l0 0c-8.46,0 -15.32,-6.86 -15.32,-15.32l0 0c0,-8.46 6.86,-15.32 15.32,-15.32z"
                  }, null, 2)
                ]),
                _hoisted_34
              ])
            ])),
            _createElementVNode("h5", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/my-beneficiary'))),
              class: "font-grey font-size-16 p-0 m-0 p-cursor"
            }, [
              _createElementVNode("b", {
                style: _normalizeStyle(_ctx.active_page=='beneficiary'? 'color:black' : '')
              }, "Manage Beneficiary", 4)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("span", _hoisted_36, [
            (_openBlock(), _createElementBlock("svg", _hoisted_37, [
              _createElementVNode("g", _hoisted_38, [
                _hoisted_39,
                _createElementVNode("g", _hoisted_40, [
                  _createElementVNode("path", {
                    class: _normalizeClass([{fil2:_ctx.active_page=='documents'}, "fil0"]),
                    d: "M17.57 1.15l0 0c8.76,0 15.87,7.11 15.87,15.87l0 0c0,8.77 -7.11,15.88 -15.87,15.88l0 0c-8.77,0 -15.87,-7.11 -15.87,-15.88l0 0c0,-8.76 7.1,-15.87 15.87,-15.87z"
                  }, null, 2),
                  _hoisted_41
                ])
              ])
            ])),
            _hoisted_42,
            _createElementVNode("h5", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/my-documents'))),
              class: "font-grey font-size-16 p-0 m-0 p-cursor"
            }, [
              _createElementVNode("b", {
                style: _normalizeStyle(_ctx.active_page=='documents'? 'color:black' : '')
              }, "Documents and References", 4)
            ])
          ]),
          _createElementVNode("p", _hoisted_43, "VERSION - " + _toDisplayString(_ctx.system_version), 1)
        ])
      ])
    ])
  ]))
}